import React from 'react';
import confirm from 'antd/lib/modal/confirm';
import { ModalProps, ModalFuncProps } from 'antd/lib/modal';
import InternalModal from './Modal';
import Icon from '../Icon';

type InternalModal = typeof InternalModal;

interface Modal extends InternalModal {
  info: typeof confirm;
  success: typeof confirm;
  error: typeof confirm;
  warning: typeof confirm;
  confirm: typeof confirm;
}

const Modal: Modal = InternalModal as Modal;

const PREFIX_CLS = 'popo-meeting';

const defalutConfig = {
  maskStyle: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  transitionName: '',
  maskTransitionName: '',
};

Modal.info = (props: ModalFuncProps) => {
  const config = {
    type: 'info',
    iconType: 'info-circle',
    okCancel: false,
    className: `${PREFIX_CLS}-modal`,
    width: 480,
    autoFocusButton: null,
    ...defalutConfig,
    ...props,
  };

  return confirm(config as any);
};

Modal.success = (props: ModalFuncProps) => {
  const config = {
    type: 'success',
    iconType: 'check-circle',
    okCancel: false,
    className: `${PREFIX_CLS}-modal`,
    width: 480,
    autoFocusButton: null,
    ...defalutConfig,
    ...props,
  };

  return confirm(config as any);
};

Modal.error = (props: ModalFuncProps) => {
  const config = {
    type: 'error',
    iconType: 'times-circle',
    className: `${PREFIX_CLS}-modal`,
    okCancel: false,
    width: 480,
    autoFocusButton: null,
    okButtonProps: {
      className: `popo-meeting-button`,
      danger: true,
    },
    ...defalutConfig,
    ...props,
  };

  return confirm(config as any);
};

Modal.warning = (props: ModalFuncProps) => {
  const config = {
    type: 'warning',
    iconType: 'exclamation-circle',
    className: `${PREFIX_CLS}-modal`,
    okCancel: false,
    width: 480,
    autoFocusButton: null,
    ...defalutConfig,
    ...props,
  };

  return confirm(config as any);
};

Modal.confirm = (props: ModalFuncProps) => {
  const config = {
    type: 'confirm',
    okCancel: true,
    className: `${PREFIX_CLS}-modal`,
    width: 480,
    autoFocusButton: null,
    closeIcon: <Icon name="icon-close_nor" size={20} style={{ color: '#8590A6' }} />,
    cancelButtonProps: {
      className: `${PREFIX_CLS}-button ${PREFIX_CLS}-cancel-button`,
    },
    ...defalutConfig,
    ...props,
  };

  return confirm(config as any);
};

export { ModalProps, ModalFuncProps };

export default Modal;
